<template>
  <div class="home-shell">
    <!--<login loginState="loginStateParents" v-if="loginStateP" v-on:chaildLoginState="chaildData"></login>-->
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <!--<router-view></router-view>-->
    <dyfooter></dyfooter>

  </div>
</template>

<script>
import dyfooter from "@/components/common/dyfooter";
import yjheader from "@/components/common/yjheader";
import login from "@/components/yj/login";

export default {
  name: "home",
  components: {
    dyfooter,
    yjheader,
    login
  },
  data() {
    return {
      // loginStateParents: true,
      // loginStateP: true,
    };
  },
  methods: {
    // chaildData(data) {
    //   this.loginStateP = false;
    // }
  }
};
</script>

<style scoped>
.home-shell {
  --safe-area-bottom: constant(safe-area-inset-bottom);
  --safe-area-bottom: env(safe-area-inset-bottom);
  --app-bottom-offset: calc(1.1rem + var(--safe-area-bottom, 0px));
}
</style>



// WEBPACK FOOTER //
// src/components/yj/home.vue